export default {
      id: "i-check-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/sprite.svg#i-check",
      toString: function () {
        return this.url;
      }
    }